export const COUNTRY_LANG_MAP = {
  CL: "es-cl",
  CO: "es-co",
  PE: "es-pe",
} as const;

export type CountryLangMap = typeof COUNTRY_LANG_MAP;
export type CountryCode = keyof CountryLangMap;
export type CountryLang = CountryLangMap[CountryCode];
